import { SIGN_TYPE_TAG } from "constant/tag/sign_type_tags.constants";
import { TopicResult } from "./dto/TopicResult";
import { ItemTag } from "common/tag/dto/ItemTag";
import { INPUT_WAY_TAG } from "constant/tag/input_way_tags.constants";

export const isWordExpressionTopic = (topic: TopicResult): boolean => {
  const searchTagResult = topic.tags.find(
    (tag: ItemTag) => tag.value === SIGN_TYPE_TAG.WORD_EXPRESSION.value
  );
  return typeof searchTagResult !== "undefined";
};

export const isRadicalCharacterTopic = (topic: TopicResult): boolean => {
  const searchTagResult = topic.tags.find(
    (tag: ItemTag) =>
      tag.value === SIGN_TYPE_TAG.RADICAL.value ||
      tag.value === SIGN_TYPE_TAG.CHARACTER.value
  );
  return typeof searchTagResult !== "undefined";
};

export const isInputWayTextTopic = (topic: TopicResult): boolean => {
  const isSignTypeWordExpression = isWordExpressionTopic(topic);
  const searchTagResult = topic.tags.find(
    (tag: ItemTag) => tag.value === INPUT_WAY_TAG.TEXT.value
  );
  return isSignTypeWordExpression && typeof searchTagResult !== "undefined";
};
